module.exports = __webpack_public_path__ + "static/media/insyt.bd529a16.svg";